import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Shared submit handler for modal dialogs that POST a confirmed action to a server endpoint.
// Server may respond with either:
//   - text/vnd.turbo-stream.html → rendered via Turbo.renderStreamMessage
//   - any other content type (e.g. xlsx) → downloaded as a file via Content-Disposition
// After either response, dispatches search:deselectAll and search:refresh, then removes the modal.
export default class extends Controller {
  static values = {
    selectedIds: String,
    url: String,
    searchParams: String,
  }

  submit = async (event) => {
    event.preventDefault()
    const button = event.currentTarget
    button.disabled = true
    button.classList.add("loading")
    const token = document.querySelector('meta[name="csrf-token"]').content

    const params = new URLSearchParams(JSON.parse(this.searchParamsValue || "{}"))
    params.set("selected_ids", this.selectedIdsValue)
    params.set("confirmed", "true")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": token,
          Accept: "text/vnd.turbo-stream.html, */*",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params.toString(),
      })
      if (!response.ok) throw new Error("Request failed")

      if (response.status === 204) {
        // success, no content — nothing to render
      } else if ((response.headers.get("Content-Type") || "").includes("text/vnd.turbo-stream.html")) {
        const html = await response.text()
        if (html) Turbo.renderStreamMessage(html)
      } else {
        const disposition = response.headers.get("Content-Disposition")
        const filename = disposition
          ? disposition.split(";")[1].split("filename=")[1].replace(/["']/g, "")
          : "download"
        const blob = await response.blob()
        const url = URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.download = filename
        link.click()
        URL.revokeObjectURL(url)
      }

      this.removeModal()
      document.dispatchEvent(new CustomEvent("search:deselectAll"))
      document.dispatchEvent(new CustomEvent("search:refresh"))
    } catch (error) {
      console.error("Confirm submit failed:", error)
      button.disabled = false
      button.classList.remove("loading")
      alert("Something went wrong. Please try again.")
    }
  }

  cancel = (event) => {
    event.preventDefault()
    this.removeModal()
  }

  removeModal = () => {
    this.element.classList.remove("active")
    setTimeout(() => this.element.remove(), 300)
  }
}
